import * as React from 'react';
export const IcLcvTop = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.45 6.11L17 5.38V4.5a1.001 1.001 0 00-.17-.5c-.13-.25-1.39-2-4.83-2-3.44 0-4.7 1.75-4.83 2a1 1 0 00-.17.5v.88l-1.45.73A1 1 0 006 8a.93.93 0 00.45-.11L7 7.62v.14l-.79 1.58a2 2 0 00-.21.9V19a3 3 0 003 3h6a3 3 0 003-3v-8.76a2 2 0 00-.21-.9L17 7.76v-.14l.55.27A.93.93 0 0018 8a1 1 0 00.45-1.89zM10.67 4h2.66A1.67 1.67 0 0115 5.67a.33.33 0 01-.33.33H9.33A.33.33 0 019 5.67 1.67 1.67 0 0110.67 4zm3.83 8h-5A1.5 1.5 0 018 10.5a.5.5 0 01.5-.5h7a.5.5 0 01.5.5 1.5 1.5 0 01-1.5 1.5z'
      fill='currentColor'
    />
  </svg>
);
